<template>
  <div class="border-style">
    <div class="flex flex-row-wrap align-center">
      <template v-for="({ name, minPoint, maxPoint, count, symbol, color }, i) in sortedValues">
        <skills-count-points
          :key="`${i}-count`"
          :minPoint="minPoint"
          :maxPoint="maxPoint"
          :count="count"
          :name="name"
          :symbol="symbol"
          :color="color"
        />
      </template>
    </div>

    <template v-if="!skillsLength || skillsNotAssignedToStimuli">
      <div class="skill-indicator ml-30 mt-20 pt-10 pb-5 mb-20">
        <p>
          <template v-if="!skillsLength">
            No Skills created yet! Once skills are created they will appear here.
          </template>
          <template v-else>
            Charts will populate when skills are assigned to emails and IMs.
          </template>
        </p>
      </div>
    </template>
    <template v-else>
      <hr class="hr-width" />
      <div class="flex flex-row-wrap align-center justify-around">
        <count-chart :countChartData="countChartData" :countChartColors="countChartColors" />
        <min-max-chart :xaxisData="xaxisData" :minMaxData="minMaxData" />
      </div>
    </template>
  </div>
</template>

<script>
  import SkillsCountPoints from './SkillsCountPoints.vue';
  import CountChart from './CountChart.vue';
  import MinMaxChart from './MinMaxChart.vue';
  import { getChartColors } from '@authoringPlatform/../store/modules/editMode/helpers';
  export default {
    data() {
      return {
        chartMaxColors: getChartColors(),
        chartMinColors: getChartColors(0.5),
      };
    },

    components: { SkillsCountPoints, CountChart, MinMaxChart },
    props: {
      skillsOverview: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },

    computed: {
      skillsLength() {
        return Object.keys(this.skillsOverview).length;
      },
      skillsNotAssignedToStimuli() {
        return Object.values(this.skillsOverview).every(({ count }) => count === 0);
      },

      sortedValues() {
        return Object.values(this.skillsOverview)
          .sort((a, b) => {
            return a.skillKey - b.skillKey;
          })
          .reduce((acc, curr, idx) => {
            acc.push({ ...curr, color: this.chartMaxColors[idx] });
            return acc;
          }, []);
      },
      countChartData() {
        return Object.values(this.skillsOverview).reduce((acc, curr) => {
          if (curr.count) acc.push({ name: curr.symbol + curr.name, y: curr.count });
          return acc;
        }, []);
      },
      countChartColors() {
        return Object.values(this.skillsOverview).reduce((acc, _, idx) => {
          acc.push(this.chartMaxColors[idx]);
          return acc;
        }, []);
      },
      xaxisData() {
        return Object.values(this.skillsOverview).reduce((acc, curr) => {
          if (curr.maxPoint || curr.minPoint) acc.push(curr.symbol + curr.name);
          return acc;
        }, []);
      },

      minMaxData() {
        return Object.values(this.skillsOverview).reduce((acc, curr, idx) => {
          if (!acc.length) {
            acc.push({ name: 'max', data: [] });
            acc.push({ name: 'min', data: [] });
          }
          if (curr.maxPoint || curr.minPoint) {
            const maxPoint = parseInt(curr.maxPoint.toFixed(0));
            // const minPoint = parseInt(curr.minPoint.toFixed(0));
            acc[0].data.push({ y: maxPoint, color: this.chartMaxColors[idx] });
            // acc[1].data.push({ y: minPoint, color: this.chartMinColors[idx] });
          }

          return acc;
        }, []);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .skill-indicator {
    background-color: #fbf5d3;
    text-align: center;
    width: 95%;
  }
  .border-style {
    border: 1px solid #dddddd;
  }
  .hr-width {
    width: 95%;
  }
</style>
